import './panzer';

const storySettingsValues = {
    'romanization': function(isOn) {
        (isOn)
            ? $('head').append('<style id="romanization">.language-ko ruby rt {display: revert;} </style>')
            : $('style#romanization').remove();
    },
    'hiragana': function(isOn) {
        (isOn)
            ? $('head').append('<style id="hiragana">ruby rt {display: none;}</style>')
            : $('style#hiragana').remove();
    },
    'spaces': function(isOn) {
        (isOn)
            ? $('head').append('<style id="spaces">span.word { margin-right: 10px; }</style>')
            : $('style#spaces').remove();
    },
    'font_size': function(isOn) {
        (isOn)
            ? $('head').append('<style id="font">span.word { font-size: 27px; } ruby rt { font-size: 14px; }</style>')
            : $('style#font').remove();
    },
    'translations': function(isOn) {
        if (!isOn) {
            $('p.translations').remove();
            return;
        }

        $('.article__text').find('p').each(function() {
            let translation = [];
            $(this).find('button.translate-sentence').each(function() {
                translation.push($(this).data('translation'));
            });
            $(this).append(`<p class="translations">${translation.join(' ')}</p>`);
        });
    },
}

Object.keys(storySettingsValues).forEach(function(key) {
    storySettingsValues[key]($('#' + key).prop('checked'));
});

$('.course-page-content.story').css('visibility', 'visible');

$(document).ready(function () {
    "use strict"; // start of use strict
/*==============================
 Story settings
 ==============================*/
$('.story-settings').change(function () {
    const $this = $(this),
        isChecked = $this.is(':checked'),
        id = $this.attr('id');

    storySettingsValues[id](isChecked);
});

/*==============================
  Popover
  ==============================*/
window.currentPeriod = '';
$('body').click(function (event) {
    if (
        !$(event.target).closest('button').hasClass('translate-sentence') &&
        !$(event.target).closest('button').hasClass('play-sentence') &&
        !$(event.target).hasClass('popover') &&
        !$(event.target).hasClass('word') &&
        !$(event.target).hasClass('popover-header') &&
        !$(event.target).hasClass('popover-body') &&
        !$(event.target).is('ruby') &&
        !$(event.target).is('rt')
        // && !$('body').hasClass('playing')
    ) {
        $('.popover.show').html('').removeClass('show');
        if (window.currentPeriod !== '') {
            $('.sentence').not(window.currentPeriod).find('.word.selected').removeClass('selected');
        } else {
            $('span.word.selected').removeClass('selected');
        }
    }
});

$(document).on('click', '.translate-sentence', function(event) {
    event.stopPropagation(); // Prevent click event from bubbling up
});

$('.translate-sentence, .word').on('click', function () {
    const $button = $(this);

    if ($button.data('translation') === '') {
        return;
    }

    $('.popover.show').html('').removeClass('show');
    if (!$('body').hasClass('playing')) {
        $('span.word.selected').removeClass('selected');
    } else {
        const thisWordSentence = '#' + $button.closest('.sentence').attr('id');
        $('.sentence').not(window.currentPeriod).find('.word.selected').removeClass('selected');
    }

    const selectedWords = $button.hasClass('word')
        ? '#'+$button.attr('id')
        : $button.closest('.sentence').find('.word').map(function() { return '#'+this.id; }).get().join(',');

    let template = '<div data-words="'+selectedWords+'">';
    template += `
                <div class="header popover-header">
                    <h3 class="popover-header">Translation</h3>
                </div>
                <div class="body popover-body">
                    ${[$button.data('word'),$button.data('translation')].filter((string) => string !== '').join(':  ')}
                </div>
            `;

    if ($button.data('base') !== '') {
        template += `
                <br>
                <div class="header">
                    <h3 class="popover-header">Base form</h3>
                </div>
                <div class="body">
                    ${$button.data('base')}: ${$button.data('basetranslation')}
                </div>
            `;
    }

    template += '</div>';

    if ($button.hasClass('word')) {
        $button
            .addClass('selected')
            .find('.popover')
            .html(template)
            .css({
                'width': $('.article__text').width(),
            })
            .addClass('show');
    } else {
        $button
            .closest('.sentence')
            .find('span.word')
            .addClass('selected')
            .closest('.sentence')
            .find('.popover.for-p')
            .html(template)
            .css({
                'width': $('.article__text').width(),
            })
            .addClass('show');
    }
});

$(window).resize(() => {
    $('.popover.show').css({
        'width': $('.article__text').width(),
    });
});

/*==============================
Player
==============================*/
$('.player__btn').on('click', function() {
    $(this).toggleClass('player__btn--active');
    if ($(this).data('panel') === 'player') {
        $('.player').toggleClass('player--active');
    }

    if ($(this).data('panel') === 'settings') {
        $('.settings').toggleClass('settings--active');
    }
});
    window.playPeriods = [];
    if ($('.play-sentence').length) {
        $('.play-sentence').each(function() {
            const self = $(this),
                start = self.data('start'),
                finish = self.data('finish'),
                sentence = self.data('sentence');

            window.playPeriods.push({start, finish, sentence});
        });
    }
    window.keepPopOverWordsSelected = function() {
        if ($('.popover.show').length) {
            $($('.popover.show').find('div').data('words')).addClass('selected');
        }
    }

    $('#panzer').panzer({
        layout: 'big',
        showduration: true,
        preload: 'auto',
        rates: {
            'slower': 0.6,
            'slow': 0.8,
            'normal': 1,
            'fast': 1.2
        }
    });


    // One-time autoplay trigger that ignores clicks on player controls
    const GESTURES = 'pointerdown touchstart touchend keydown click',
        startPlayback = () => {
            $('#panzer').panzer('playUntil', 0, 0.01);
        };

    const isExcludedGesture = (target) =>
        $(target).closest('.plyr__control, .play-pause, .play, .play-sentence').length > 0;

    const onFirstGesture = (e) => {
        if (isExcludedGesture(e.target)) {
            // Re-arm to keep waiting for a valid user gesture
            $(document).one(GESTURES, onFirstGesture);
            return;
        }
        startPlayback(); // assumes startPlayback is defined elsewhere
    };

    // $(document).one(GESTURES, onFirstGesture);

    $('.player').show();


    $('.play-sentence').on('click', function() {
        const self = $(this),
            start = self.data('start'),
            finish = self.data('finish');

        $('.word').removeClass('selected');

        $(self.data('sentence')).find('.word').addClass('selected');

        $('#panzer').panzer('playUntil', start, finish);
    });


// Event listener for time updates
// player.on('timeupdate', () => {
//     if (!$('body').hasClass('playing')) {
//         $('body').addClass('playing');
//     }
//
//     playPeriods.forEach(period => {
//         if (player.currentTime >= period.start && player.currentTime <= period.finish) {
//             if (currentPeriod !== period.sentence) {
//                 $('.word').removeClass('selected');
//                 keepPopOverWordsSelected();
//             }
//             currentPeriod = period.sentence;
//             $(period.sentence).find('.word').addClass('selected');
//         }
//     });
//
//     if (currentEndTime !== null && player.currentTime >= currentEndTime) {
//         player.pause();
//         currentEndTime = null; // Reset the end time
//     }
// });




/* playlist */
});
